import { computed } from 'vue'
import { useRoute } from '#app/composables/router'
import { DEFAULT_SORT_VALUE_KEY } from '~/config/defaultConfigs'
import { getSortByValue } from '../utils/sort'

export default () => {
  const defaultQuery = ''

  const route = useRoute()

  const sort = computed(() => {
    const query = Array.isArray(route.query.sort)
      ? route.query.sort[0]
      : route.query.sort

    return query || defaultQuery
  })
  const selectedSort = computed(() =>
    getSortByValue(sort.value, DEFAULT_SORT_VALUE_KEY),
  )

  const isDefaultSort = computed(
    () =>
      selectedSort.value ===
      getSortByValue(defaultQuery, DEFAULT_SORT_VALUE_KEY),
  )

  const selectedSortName = computed(() => selectedSort.value.name)

  return { selectedSort, selectedSortName, isDefaultSort }
}
